<div class="customer-search-container">
    <div class="search-field-input">
        <span class="customer-search-svg-icon">
            <ng-icon name="tablerSearch"></ng-icon>
        </span>
        <input [(ngModel)]="searchText" (keyup)="onSearch()" type="text" [placeholder]="placeholder"
            class="searchBox form-control search-field-pad">
    </div>
    <div *ngIf="showSearchBar()" class="customer-search-filter-btns" style="margin-top: -5px !important;">
        <div class="flex-start-gap">
            <ng-container *ngIf="activeScreen != 'TOPUP'">
                <!-- (menuOpened)="onMenuOpened()" (menuClosed)="onMenuClosed()" -->
                <button *ngIf="checksuperadmin()"  yPosition="below" xPosition="after" [matMenuTriggerFor]="menu" type="button"
                    class="btn btn-primary svg-funnel" >
                    <span>
                        Filter
                    </span>
                    <ng-icon name="tablerFilter"></ng-icon>
                </button>
                <button *ngIf="activeScreen != 'TOPUP'" (click)="downloadExcel()"
                    class="btn  btn-primary svg-excel">
                    <ng-icon name="tablerFileSpreadsheet"></ng-icon>
                    Download
                </button>

            </ng-container>
        </div>
    </div>
</div>

<div class="customer-search-menu-host">
    <mat-menu #menu="matMenu" xPosition="before" class="filter-panel-menu">
        <div class="filter-panel" (click)="$event.stopPropagation()">
            <div class="filter-panel-header">
                <span class="filter-panel-title">Filters</span>
                <button class="filter-clear-btn" *ngIf="hasActiveFilters()" (click)="clearAllFilters()">
                    Clear all
                </button>
            </div>
            <div class="filter-panel-body">
                <ng-container *ngFor="let fData of filterContext">
                    <div class="filter-section">
                        <div class="filter-section-title">{{ fData.label }}</div>

                        <!-- Toggle bar option -->
                        <ng-container *ngIf="fData?.showTogglebar; else checkboxList">
                            <div class="filter-toggle-wrapper">
                                <label class="custom-switch">
                                    <input type="checkbox" (click)="$event.stopPropagation()"
                                        [(ngModel)]="filterData[fData?.payload]">
                                    <span class="custom-slider">
                                        <span class="on">On</span>
                                        <span class="off">Off</span>
                                    </span>
                                </label>
                            </div>
                        </ng-container>

                        <!-- Checkbox list -->
                        <ng-template #checkboxList>
                            <div class="filter-checkbox-list">
                                <label class="filter-checkbox-item" *ngFor="let option of fData.options">
                                    <input type="checkbox"
                                        [checked]="isFilterSelected(fData.payload, option.value)"
                                        (change)="toggleFilter(fData.payload, option.value, $event, getMultiple(fData))" />
                                    <span class="filter-checkmark"></span>
                                    <span class="filter-label-text">{{ option.label }}</span>
                                </label>
                            </div>
                        </ng-template>
                    </div>
                </ng-container>
            </div>
            <div class="filter-panel-footer">
                <button class="filter-cancel-btn" (click)="menu.close.emit()">Cancel</button>
                <button class="filter-apply-btn" (click)="saveFilter(); menu.close.emit()">
                    Apply <span *ngIf="getActiveFilterCount() > 0">({{ getActiveFilterCount() }})</span>
                </button>
            </div>
        </div>
    </mat-menu>
</div>
